/**
 * 대시보드 세션 UI — 페이지 새로고침 persist에 남기면 안 되는 선택 상태.
 * 이전 모듈 하이라이트가 복원된 뒤 새 선택과 겹친다.
 */
export function stripDashboardSessionSelection(dashboard) {
  if (!dashboard || typeof dashboard !== 'object') {
    return dashboard;
  }
  const next = { ...dashboard };
  delete next.mapHighlightTarget;
  delete next.moduleClickTarget;
  return next;
}
